import { Box } from '@chakra-ui/react';
import React from 'react';

const SpacerComponent = ({...props}) => {
  return <Box flexGrow={1} {...props} />;
};

export default SpacerComponent;
